import { render, staticRenderFns } from "./publicComponent.vue?vue&type=template&id=4e534b1a&"
import script from "./publicComponent.vue?vue&type=script&lang=js&"
export * from "./publicComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports